// extracted by mini-css-extract-plugin
export default {"row":"styles_row__+Xvu8","summery":"styles_summery__V2cab"};